export default function EmptyState({ icon = 'inbox', title = 'Nothing here yet', children }) {
  return (
    <div className="empty">
      <i className={`bi bi-${icon}`} />
      <p style={{ fontWeight: 600, color: 'var(--ink)' }}>{title}</p>
      {children && <p>{children}</p>}
    </div>
  );
}
